import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import profileActions from "../../redux/profile/actions";
import LeftSideComponent from "./leftSideComponent";
import ConnectionsList from "./connectionsList";
import SearchComponent from "./searchComponent";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    top: "50px",
    position: "relative",
    left: "-50px",
  },
  cover: {
    width: 73,
    height: 73,
    borderRadius: "50%",
  },
}));

const Connections = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loading, currentUser, pendingCreditz = [], pendingConnections =[] } = useSelector((state) => ({
    loading: state.creditz.loading,
    newCreditzCreated: state.creditz.newCreditzCreated,
    newCreditz: state.creditz.newCreditz,
    additionalRoles: state.creditz.additionalRoles,
    currentUser: state.profile.currentUser,
    pendingConnections: state.connection.pending,
    pendingCreditz: state.creditz.pending
  }));

  const [selected, setSelected] = useState("CreditzList");

  useEffect(() => {
    dispatch({
      type: profileActions.GET_USER_MUSICS,
    });
  }, []);

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
      </Backdrop>
      <div className={styles.mainComponent}>
        <div className={styles.mainContent}>
          <div className={styles.leftContainer}>
            <LeftSideComponent
              history={history}
              currentUser={currentUser}
              pending={
                pendingCreditz.filter((c) => c.notification.status === 1).length
              }
              pendingConnections={pendingConnections.length}
            />
          </div>
          <div className={styles.rightContainer}>
            <ConnectionsList setAddNewCreditz={setSelected} />
          </div>
          <div className={styles.searchContainer}>
            <SearchComponent />
          </div>
        </div>
      </div>
    </>
  );
};

Connections.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Connections);
